import React from 'react';
import Icon from '../icon/Icon';
import { Icon as IconObject } from '../../core/constants/Icon';

import './NoResultsPage.scss';

type IconName = keyof typeof IconObject;

interface Props {
  title: string;
  description: string;
  icon?: IconName;
  iconClass?: string;
}

const NoResultsPage: React.FC<Props> = ({ title, description, icon, iconClass }) => {
  return (
    <div className="no-results-page__no-data">
      {icon && <Icon className={`no-results-page__no-data-icon ${iconClass}`} icon={icon as IconName} size="full-size" svg />}
      <span className="no-results-page__no-data-title">{title}</span>
      <span className="no-results-page__no-data-text">{description}</span>
    </div>
  );
};

export default NoResultsPage;
